import Oystehr from '@oystehr/sdk';
import { ChangeInPersonVisitStatusInput } from 'utils/lib/types/api/change-in-person-visit-status/change-in-person-visit-status.types';
import { changeInPersonVisitStatus } from '../api/api';

export const handleChangeInPersonVisitStatus = async (
  zambdaInput: ChangeInPersonVisitStatusInput,
  oystehr?: Oystehr
): Promise<void> => {
  const { encounterId, updatedStatus } = zambdaInput;
  if (!encounterId) {
    throw new Error('Encounter ID is required to change the visit status');
  }
  if (!oystehr) {
    throw new Error('Oystehr Zambda client is not available when changing the visit status');
  }
  try {
    await changeInPersonVisitStatus(oystehr, {
      encounterId,
      updatedStatus,
    });
  } catch (error: any) {
    throw new Error(error.message);
  }
};
